import { render, staticRenderFns } from "./AddNewProject.vue?vue&type=template&id=67d7e051&"
import script from "./AddNewProject.vue?vue&type=script&lang=js&"
export * from "./AddNewProject.vue?vue&type=script&lang=js&"
import style0 from "./AddNewProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports